export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100/50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-400 bg-primary-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-information-line"></i>
            About Us
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500">了解51黑料网的故事与使命</p>
        </div>

        <div className="bg-background-50 border border-background-200/60 rounded-xl p-8 md:p-10">
          <div className="space-y-4">
            <p className="text-sm text-foreground-400 leading-relaxed">
              51黑料网诞生于互联网信息爆炸的时代。我们注意到，虽然社交媒体让信息传播更加便利，
              但也让真实有价值的爆料淹没在大量噪音之中。于是，一个专注于<strong className="text-primary-400 font-semibold">今日黑料最新</strong>动态的聚合平台应运而生。
            </p>
            <p className="text-sm text-foreground-400 leading-relaxed">
              作为中文互联网领先的黑料每日更新平台，51黑料网坚持"快、准、深"的三字原则：
              以最快速度追踪<strong className="text-primary-400 font-semibold">51黑料今日</strong>热点，以多源交叉验证确保信息准确，
              以独到视角提供<strong className="text-accent-400 font-semibold">黑料新鲜事</strong>的深度解读。
            </p>
            <p className="text-sm text-foreground-400 leading-relaxed">
              无论你是资深吃瓜群众还是偶尔关注的过路人，51黑料网都致力于成为你获取
              <strong className="text-primary-400 font-semibold">每日黑料</strong>的第一选择。
              收藏51黑料网入口，每天花几分钟，不错过娱乐圈与互联网世界的每一次精彩爆料。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-6 mt-8 pt-6 border-t border-background-200/60">
            <div className="text-center">
              <p className="text-2xl font-bold text-primary-400 font-heading">5年+</p>
              <p className="text-xs text-foreground-600 mt-1">持续运营</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-accent-400 font-heading">300万+</p>
              <p className="text-xs text-foreground-600 mt-1">月活用户</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-primary-400 font-heading">10万+</p>
              <p className="text-xs text-foreground-600 mt-1">累计爆料</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-accent-400 font-heading">50+</p>
              <p className="text-xs text-foreground-600 mt-1">追踪信源</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}